import { GetServerSideProps, NextPage } from 'next'
import { GlobalRequest } from '~/components/global-requset'
import { Container } from '~/components/ui/Container'
import { Layout } from '~/layouts/default'
import styled from 'styled-components'
import { SwapRightOutlined } from '@ant-design/icons'
import { PageBanner } from '~/components/business/PageBanner'
import { PageSection } from '~/components/business/PageSection'
import { SEOHead } from '~/components/business/SEOHead'
import { MyBtn } from '~/components/ui/MyBtn'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import { useRouter } from 'next/router'
import { GET_AI_MEMBER_LIST } from '~/graphqls/gqls'
import {
  AccountGroupTypeEnum,
  getAIMemberList,
  getAIMemberList_accountModule_userMemberCardList,
  MemberCardRightTypeEnum,
} from '~/graphqls/types'
import { Modal } from 'antd'
import { useCallback } from 'react'

const { confirm } = Modal

const StyledCopyright = styled.div``

const StyledServiceList = styled.div`
  display: flex;
  justify-content: space-between;
`

const StyledServiceItem = styled.div`
  position: relative;
  border: 1px solid ${props => props.theme.light1};
  border-radius: 16px;
  text-align: center;
  height: 248px;
  width: 200px;
  padding: 40px 16px 32px;
  transition: all 0.3s ease;

  &.editable {
    cursor: pointer;
    &:hover {
      transition: all 0.3s ease;
      border-color: ${props => props.theme.primaryColor};
    }
  }
`

const StyledServiceItemIcon = styled.img`
  position: relative;
  width: 44px;
  height: 44px;
  margin-bottom: 12px;
`

const StyledServiceItemTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: ${props => props.theme.dark1};
`

const StyledServiceItemDesc = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${props => props.theme.dark4};
`

const StyledServiceItemAction = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 32px;
  color: ${props => props.theme.dark4};
  .ant-btn {
    line-height: 16px;
    padding: 4px 10px;
    height: 32px;
  }
`

const serviceData = [
  {
    icon: '/images/us/copyright/service-2.svg',
    title: '版权登记',
    desc: '为用户提供版权著作权自助登记服务，保护原创者的利益',
  },
  {
    icon: '/images/us/copyright/service-3.svg',
    title: '司法取证',
    desc: '取证证据直通互联网法院，为用户提供在线取证服务',
  },
  {
    icon: '/images/us/copyright/service-4.svg',
    title: '版权监测',
    desc: '在线监测是否被侵权，并把结果发持有者，维护持有者利益',
  },
  {
    icon: '/images/us/copyright/service-5.svg',
    title: '维权服务',
    desc: '专业的版权法律在线咨询服务',
  },
]

const advantageData = [
  {
    icon: '/images/us/copyright/advantage-1.svg',
    title: '免费',
    desc: '为平台上的创作者、版权所有权者提供免费的区块链版权存证、版权监测等服务',
  },
  {
    icon: '/images/us/copyright/advantage-2.svg',
    title: '全面',
    desc: '为用户提供版权存证、版权登记、版权监测、司法取证等全面的版权保护服务',
  },
  {
    icon: '/images/us/copyright/advantage-3.svg',
    title: '安全',
    desc: '数字版权存证上链，操作便捷真实可信，上链数据可核验，加强证据效力',
  },
  {
    icon: '/images/us/copyright/advantage-4.svg',
    title: '专业',
    desc: '平台依托区块链和大数据技术，为每一层服务提供更加安全可信的基石',
  },
]
const WUJIEAI_HOST = process.env.NEXT_PUBLIC_WUJIEAI_HOST
const Copyright: NextPage<{
  aiMemberList: getAIMemberList_accountModule_userMemberCardList[]
}> = ({ aiMemberList }) => {
  const { validateIsLogin } = useValidateAuth()
  const router = useRouter()

  // 免费存证次数
  let evidenceCount = 0
  aiMemberList?.forEach(card => {
    card.holdCardInfo?.forEach(i => {
      if (i?.rightType === MemberCardRightTypeEnum.EVIDENCE_CREATE) {
        evidenceCount += i.num || 0
      }
    })
  })
  const onCertificate = useCallback(() => {
    if (validateIsLogin()) {
      if (evidenceCount > 0) {
        router.push('/upload-certificate')
      } else {
        confirm({
          closable: true,
          title: '提示',
          content: '购买AI创作权益卡可赠送免费存证次数',
          icon: '',
          maskStyle: {
            backgroundColor: 'rgba(0,0,0,0.8)',
          },
          width: 300,
          onOk: () => {
            window.open(WUJIEAI_HOST + '/ai/equity-card')
          },
          okText: '开通权益卡',
          cancelText: '取消',
        })
      }
    }
  }, [validateIsLogin, evidenceCount])

  return (
    <Layout>
      <SEOHead title="版权保护" desc="提供一站式版权保护综合服务" />
      <StyledCopyright>
        <PageBanner bg="/images/us/copyright/banner@2x.jpg">
          提供一站式版权保护综合服务
        </PageBanner>
        <Container>
          <PageSection title="我们提供的服务">
            <StyledServiceList>
              <StyledServiceItem>
                <StyledServiceItemIcon src="/images/us/copyright/service-1.svg" />
                <StyledServiceItemTitle>版权存证</StyledServiceItemTitle>
                <StyledServiceItemDesc>
                  直通互联网法院司法认证的区块链版权存证服务
                </StyledServiceItemDesc>
                <StyledServiceItemAction>
                  <MyBtn type="primary" onClick={onCertificate}>
                    立即存证
                  </MyBtn>
                </StyledServiceItemAction>
              </StyledServiceItem>

              {serviceData.map(service => {
                return (
                  <StyledServiceItem key={service.title}>
                    <StyledServiceItemIcon src={service.icon} />
                    <StyledServiceItemTitle>
                      {service.title}
                    </StyledServiceItemTitle>
                    <StyledServiceItemDesc>
                      {service.desc}
                    </StyledServiceItemDesc>
                    <StyledServiceItemAction>
                      <SwapRightOutlined style={{ fontSize: 20 }} />
                    </StyledServiceItemAction>
                  </StyledServiceItem>
                )
              })}
            </StyledServiceList>
          </PageSection>
          <PageSection title="产品优势">
            <StyledServiceList>
              {advantageData.map(service => {
                return (
                  <StyledServiceItem
                    style={{
                      height: 204,
                      width: 256,
                      padding: '36px 40px 32px',
                    }}
                    key={service.title}
                  >
                    <StyledServiceItemIcon src={service.icon} />
                    <StyledServiceItemTitle>
                      {service.title}
                    </StyledServiceItemTitle>
                    <StyledServiceItemDesc>
                      {service.desc}
                    </StyledServiceItemDesc>
                  </StyledServiceItem>
                )
              })}
            </StyledServiceList>
          </PageSection>
        </Container>
      </StyledCopyright>
    </Layout>
  )
}

export const getServerSideProps: GetServerSideProps = async context => {
  const { initialState, client } = await GlobalRequest(context)

  const aiMemberListRes = await client.query<getAIMemberList>({
    query: GET_AI_MEMBER_LIST,
    variables: {
      groupList: [
        AccountGroupTypeEnum.BLANK_PASS,
        AccountGroupTypeEnum.BRONZE_CARD,
        AccountGroupTypeEnum.GOLD_CARD,
        AccountGroupTypeEnum.ORIGIN_CARD,
        AccountGroupTypeEnum.PLATINUM_CARD,
        AccountGroupTypeEnum.SILVER_CARD,
      ],
    },
    fetchPolicy: 'no-cache',
  })

  return {
    props: {
      initialState,
      aiMemberList:
        aiMemberListRes.data.accountModule?.userMemberCardList || [],
    },
  }
}

export default Copyright
